import { createIcon } from "../create-icon"

export const DeleteOutlineIcon = createIcon({
  title: "DeleteOutlineIcon",
  viewBox: "0 0 16 16",
  path: (
    <>
      <g clipPath="url(#clip0_10527_2984)">
        <path
          d="M4 6H4.5V5.5H4V6ZM4 12H3.5H4ZM12 6V5.5H11.5V6H12ZM3.5 5C3.5 4.72386 3.72386 4.5 4 4.5V3.5C3.17157 3.5 2.5 4.17157 2.5 5H3.5ZM4 5.5C3.72386 5.5 3.5 5.27614 3.5 5H2.5C2.5 5.82843 3.17157 6.5 4 6.5V5.5ZM4.5 12L4.5 6H3.5L3.5 12H4.5ZM5 12.5C4.72386 12.5 4.5 12.2761 4.5 12H3.5C3.5 12.8284 4.17157 13.5 5 13.5V12.5ZM11 12.5H5V13.5H11V12.5ZM11.5 12C11.5 12.2761 11.2761 12.5 11 12.5V13.5C11.8284 13.5 12.5 12.8284 12.5 12H11.5ZM11.5 6V12H12.5V6H11.5ZM12.5 5C12.5 5.27614 12.2761 5.5 12 5.5V6.5C12.8284 6.5 13.5 5.82843 13.5 5H12.5ZM12 4.5C12.2761 4.5 12.5 4.72386 12.5 5H13.5C13.5 4.17157 12.8284 3.5 12 3.5V4.5ZM4 4.5H12V3.5H4V4.5Z"
          fill="currentColor"
        />
        <path
          opacity="0.95"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 3.5C6 2.94772 6.44772 2.5 7 2.5H9C9.55228 2.5 10 2.94772 10 3.5H6ZM6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5V10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5V7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5V10.5C9 10.7761 9.22386 11 9.5 11C9.77614 11 10 10.7761 10 10.5V7.5C10 7.22386 9.77614 7 9.5 7Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10527_2984">
          <rect
            width="12"
            height="12"
            fill="currentColor"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

DeleteOutlineIcon.displayName = "DeleteOutlineIcon"
